import ApiResourceManager from '../ApiResourceManager';

export default class ImpressumManager extends ApiResourceManager {
  get = (params) =>
    this.request({
      method: 'GET',
      url: '/current-company/impressum',
      params,
    });

  update = (data) =>
    this.request({
      method: 'PUT',
      url: '/current-company/impressum',
      data,
    });
}
